import { useNavigate } from "react-router-dom";
// INFO: after a successful sign-in the user is normally sent to "/". A flow that needs the
// user back on a specific in-app route (e.g. the MCP connector consent screen) stores that
// route here first; we consume it once and clear it. The old document.referrer approach was
// unreliable (empty on cross-origin, includes the /auth page itself), hence this explicit
// hand-off via sessionStorage.
var RETURN_URL_KEY = "rentio:auth:returnUrl";
// INFO: only same-origin absolute paths are allowed, to avoid an open redirect. Must start
// with a single "/" (not "//", which is protocol-relative and points off-site).
var isSafeInternalPath = function (value) {
    return !!value && value.startsWith("/") && !value.startsWith("//");
};
export var setReturnUrlAfterLogin = function (path) {
    try {
        if (isSafeInternalPath(path)) {
            sessionStorage.setItem(RETURN_URL_KEY, path);
        }
    }
    catch (_a) {
        // sessionStorage can be unavailable (private mode); the flow still works, just without
        // the return hand-off.
    }
};
var consumeReturnUrl = function () {
    try {
        var value = sessionStorage.getItem(RETURN_URL_KEY);
        if (value) {
            sessionStorage.removeItem(RETURN_URL_KEY);
        }
        return isSafeInternalPath(value) ? value : null;
    }
    catch (_a) {
        return null;
    }
};
export var useNavigateAfterSuccess = function () {
    var navigate = useNavigate();
    var navigateAfterSuccess = function () {
        var returnUrl = consumeReturnUrl();
        navigate(returnUrl !== null && returnUrl !== void 0 ? returnUrl : "/", { replace: true });
    };
    return navigateAfterSuccess;
};
